import Reveal from "./Reveal";
import { IMG } from "../data/content";
import { Check } from "lucide-react";

export default function FeatureSections() {
  return (
    <>
      <section id="already-licensed" data-testid="already-licensed-section" className="relative py-12 lg:py-16">
        <div className="max-w-6xl mx-auto px-5 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.28em] text-sky-400">Already Licensed?</p>
            <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white">
              The Breeze Difference.
            </h2>
            <p className="mt-4 text-sm sm:text-base text-slate-400 leading-relaxed">
              Tired of doing everything right - and still feeling stuck? We built Breeze for you.
            </p>
            <ul className="mt-7 space-y-4">
              {[
                "Warm and exclusive IUL & general life leads",
                "Automated & AI systems that scale with you",
                "Routine agency trainings, 1 on 1 personalized coaching, and an interactive training platform",
              ].map((b) => (
                <li key={b} className="flex items-start gap-3 text-sm sm:text-base text-slate-200">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-sky-400/15 border border-sky-400/30">
                    <Check className="h-3.5 w-3.5 text-sky-300" />
                  </span>
                  {b}
                </li>
              ))}
            </ul>
            <p className="mt-7 text-base sm:text-lg font-bold text-white">
              We'll help you scale your business to new heights and hit your targets
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="relative">
              <div className="absolute -inset-4 rounded-[28px] bg-gradient-to-tr from-sky-500/20 via-transparent to-blue-600/20 blur-xl" aria-hidden="true" />
              <div className="relative glass-card rounded-[24px] p-3 float-slow">
                <img
                  src={IMG.licensed}
                  alt="Agent working remotely with leads, CRM and training"
                  loading="lazy"
                  className="w-full rounded-2xl object-cover"
                />
              </div>
            </div>
          </Reveal>
        </div>
      </section>

      <section id="culture" data-testid="culture-section" className="relative py-12 lg:py-16">
        <div className="max-w-6xl mx-auto px-5 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <Reveal className="order-2 lg:order-1">
            <div className="relative">
              <div className="absolute -inset-4 rounded-[28px] bg-gradient-to-tl from-sky-500/20 via-transparent to-blue-600/20 blur-xl" aria-hidden="true" />
              <div className="relative glass-card rounded-[24px] p-3 float-slow" style={{ animationDelay: "1.4s" }}>
                <img
                  src={IMG.culture}
                  alt="Breeze team celebrating a sales leaderboard winner"
                  loading="lazy"
                  className="w-full rounded-2xl object-cover"
                />
              </div>
            </div>
          </Reveal>
          <Reveal delay={0.1} className="order-1 lg:order-2">
            <p className="text-xs font-semibold uppercase tracking-[0.28em] text-sky-400">The Team</p>
            <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white">
              Culture Built for Winning
            </h2>
            <p className="mt-4 text-sm sm:text-base text-slate-400 leading-relaxed">
              We surround you with winners who hold you to your goals and help you crush them.
            </p>
            <ul className="mt-7 space-y-4">
              {[
                "Performance driven comp structure with real upside & scalable incentives",
                "Access to top producers who actually coach you - not just flex their stats",
                "Competitive environment with a family vibe. We don't babysit - we build",
              ].map((b) => (
                <li key={b} className="flex items-start gap-3 text-sm sm:text-base text-slate-200">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-sky-400/15 border border-sky-400/30">
                    <Check className="h-3.5 w-3.5 text-sky-300" />
                  </span>
                  {b}
                </li>
              ))}
            </ul>
            <p className="mt-7 text-base sm:text-lg font-bold text-white">
              At Breeze Financial Group, we want to see you win
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
